import { action, computed, observable, runInAction, makeObservable } from 'mobx';

class ComingSoonFeaturesStore {
    modalHeader?: string;
    modalTextContent?: string;
    modalVisible?: boolean = false;

    constructor() {
        makeObservable(this, {
            modalHeader: observable,
            modalTextContent: observable,
            modalVisible: observable,

            setModalHeader: action,
            setModalTextContent: action,
            setModalVisible: action,
        });
    }

    setModalHeader(value: string) {
        this.modalHeader = value;
    }

    setModalTextContent(value: string) {
        this.modalTextContent = value;
    }

    setModalVisible(value: boolean) {
        this.modalVisible = value;
    }
}

export default new ComingSoonFeaturesStore();
